import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card shadow-sm" }
const _hoisted_2 = { class: "card-header d-flex justify-content-between align-items-center" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "badge bg-secondary ms-2" }
const _hoisted_5 = { class: "d-flex gap-2" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["value"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "card-body p-0" }
const _hoisted_11 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_12 = {
  key: 1,
  class: "text-center py-5 text-muted"
}
const _hoisted_13 = {
  key: 2,
  class: "table-responsive"
}
const _hoisted_14 = { class: "table table-sm align-middle mb-0" }
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "ps-2 text-nowrap text-center small" }
const _hoisted_18 = {
  class: "text-truncate",
  style: {"max-width":"12rem"}
}
const _hoisted_19 = { class: "fw-bold text-dark text-truncate" }
const _hoisted_20 = {
  key: 0,
  class: "text-muted text-truncate d-block"
}
const _hoisted_21 = { class: "text-end text-nowrap" }
const _hoisted_22 = { class: "small text-muted" }
const _hoisted_23 = { class: "text-end text-nowrap" }
const _hoisted_24 = { class: "small text-muted" }
const _hoisted_25 = { class: "text-end text-nowrap" }
const _hoisted_26 = { class: "fw-bold" }
const _hoisted_27 = { class: "small text-muted" }
const _hoisted_28 = { class: "text-center" }
const _hoisted_29 = {
  class: "text-truncate",
  style: {"max-width":"10rem"}
}
const _hoisted_30 = ["href", "title"]
const _hoisted_31 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_32 = {
  key: 2,
  class: "small text-muted mt-1"
}
const _hoisted_33 = {
  key: 0,
  class: "bg-light"
}
const _hoisted_34 = {
  colspan: "8",
  class: "p-3"
}
const _hoisted_35 = { class: "table-responsive bg-white border rounded" }
const _hoisted_36 = { class: "table table-sm align-middle mb-0" }
const _hoisted_37 = { class: "text-center" }
const _hoisted_38 = ["title"]
const _hoisted_39 = { class: "text-center" }
const _hoisted_40 = { class: "text-end text-nowrap" }
const _hoisted_41 = { class: "text-end text-nowrap" }
const _hoisted_42 = { class: "ps-4" }
const _hoisted_43 = {
  key: 0,
  class: "d-flex align-items-center justify-content-between px-2 py-2"
}
const _hoisted_44 = { class: "text-muted small" }
const _hoisted_45 = { "aria-label": "Paginación de retiros" }
const _hoisted_46 = { class: "pagination pagination-sm mb-0" }
const _hoisted_47 = ["disabled"]
const _hoisted_48 = ["disabled"]
const _hoisted_49 = {
  key: 0,
  class: "page-item disabled"
}
const _hoisted_50 = ["disabled", "onClick"]
const _hoisted_51 = {
  key: 1,
  class: "page-item disabled"
}
const _hoisted_52 = ["disabled"]
const _hoisted_53 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[6] || (_cache[6] = _createElementVNode("h5", { class: "mb-0" }, "Retiros Realizados", -1)),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.sentTotalCount), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterMonth) = $event)),
          class: "form-select form-select-sm",
          style: {"width":"auto"},
          disabled: _ctx.isSentLoading
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.months, (name, index) => {
            return (_openBlock(), _createElementBlock("option", {
              key: index,
              value: index
            }, _toDisplayString(name), 9, _hoisted_7))
          }), 128))
        ], 8, _hoisted_6), [
          [_vModelSelect, _ctx.filterMonth]
        ]),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterYear) = $event)),
          class: "form-select form-select-sm",
          style: {"width":"auto"},
          disabled: _ctx.isSentLoading
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.years, (year) => {
            return (_openBlock(), _createElementBlock("option", {
              key: year,
              value: year
            }, _toDisplayString(year), 9, _hoisted_9))
          }), 128))
        ], 8, _hoisted_8), [
          [_vModelSelect, _ctx.filterYear]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[7] || (_cache[7] = [
            _createElementVNode("div", {
              class: "spinner-border text-primary",
              role: "status"
            }, [
              _createElementVNode("span", { class: "visually-hidden" }, "Cargando...")
            ], -1)
          ]))]))
        : (_ctx.items.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [...(_cache[8] || (_cache[8] = [
              _createElementVNode("i", { class: "fas fa-inbox fa-3x mb-3" }, null, -1),
              _createElementVNode("p", null, "No hay retiros enviados registrados.", -1)
            ]))]))
          : (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("table", _hoisted_14, [
                _cache[11] || (_cache[11] = _createElementVNode("thead", { class: "table-light" }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", { style: {"width":"2.5rem"} }),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "ps-2 text-center"
                    }, "Enviado"),
                    _createElementVNode("th", { scope: "col" }, "Concepto"),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-end text-nowrap"
                    }, "Subtotal"),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-end text-nowrap"
                    }, "Comisión"),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-end text-nowrap"
                    }, "Total"),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-center text-nowrap"
                    }, "Estatus"),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-center"
                    }, "TX Hash")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items as WithdrawalRequestUI[], (item) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: item._id
                    }, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_15, [
                          _createElementVNode("a", {
                            role: "button",
                            class: _normalizeClass([
                      'fas',
                      _ctx.expanded[item._id]
                        ? 'fa-chevron-down'
                        : 'fa-chevron-right',
                      'fa-fw',
                      'm-1',
                      'text-decoration-none',
                      'link-secondary',
                    ]),
                            href: "#",
                            onClick: _withModifiers(($event: any) => (_ctx.toggleExpand(item._id)), ["prevent"])
                          }, null, 10, _hoisted_16)
                        ]),
                        _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.formatDateTimezone(item.dateUpdated)), 1),
                        _createElementVNode("td", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, _toDisplayString(item.concept), 1),
                          (item.note)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_20, _toDisplayString(item.note), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_21, [
                          _createElementVNode("div", null, _toDisplayString(_ctx.formatBtc(_ctx.calculateSubtotalBtc(item))), 1),
                          _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.formatUsdSmall(_ctx.calculateSubtotalUsd(item))), 1)
                        ]),
                        _createElementVNode("td", _hoisted_23, [
                          _createElementVNode("div", null, _toDisplayString(_ctx.formatBtc(item.feeBtc || 0)), 1),
                          _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.formatUsdSmall(item.feeUsd || 0)), 1)
                        ]),
                        _createElementVNode("td", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.formatBtc(item.totalBtc)), 1),
                          _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.formatUsdSmall(item.totalUsd)), 1)
                        ]),
                        _createElementVNode("td", _hoisted_28, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["badge", _ctx.getTxStatusClass(item.txStatus)])
                          }, [
                            _createElementVNode("i", {
                              class: _normalizeClass([_ctx.getTxStatusIcon(item.txStatus), "me-1"])
                            }, null, 2),
                            _createTextVNode(" " + _toDisplayString(_ctx.getTxStatusLabel(item.txStatus)), 1)
                          ], 2)
                        ]),
                        _createElementVNode("td", _hoisted_29, [
                          (item.txHash)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: _ctx.getExplorerLink(item.txHash),
                                target: "_blank",
                                class: "link-success small",
                                title: item.txHash
                              }, _toDisplayString(item.txHash), 9, _hoisted_30))
                            : (_openBlock(), _createElementBlock("span", _hoisted_31, "-")),
                          (item.btcPriceAtBroadcast)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, " BTC @ " + _toDisplayString(_ctx.formatUsdSmall(item.btcPriceAtBroadcast)), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      (_ctx.expanded[item._id])
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_33, [
                            _cache[10] || (_cache[10] = _createElementVNode("td", {
                              class: "bg-secondary bg-gradient",
                              style: {"--bs-bg-opacity":"0.1"}
                            }, null, -1)),
                            _createElementVNode("td", _hoisted_34, [
                              _createElementVNode("div", _hoisted_35, [
                                _createElementVNode("table", _hoisted_36, [
                                  _cache[9] || (_cache[9] = _createElementVNode("thead", { class: "table-secondary" }, [
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("th", {
                                        class: "text-center",
                                        style: {"width":"3rem"}
                                      }, "#"),
                                      _createElementVNode("th", { class: "col-3" }, "Dirección"),
                                      _createElementVNode("th", { class: "text-center col-1" }, "Moneda"),
                                      _createElementVNode("th", { class: "text-end col-2" }, "Monto (USD)"),
                                      _createElementVNode("th", { class: "text-end col-2" }, "Monto (BTC)"),
                                      _createElementVNode("th", { class: "col ps-4" }, "Nota")
                                    ])
                                  ], -1)),
                                  _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.destinations, (dest, index) => {
                                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                        _createElementVNode("td", _hoisted_37, _toDisplayString(index + 1), 1),
                                        _createElementVNode("td", null, [
                                          _createElementVNode("div", {
                                            class: "user-select-all text-truncate",
                                            title: dest.address
                                          }, _toDisplayString(dest.address), 9, _hoisted_38)
                                        ]),
                                        _createElementVNode("td", _hoisted_39, [
                                          _createElementVNode("span", {
                                            class: _normalizeClass(["badge", _ctx.currencyBadgeClass(dest.currency)])
                                          }, _toDisplayString(dest.currency), 3)
                                        ]),
                                        _createElementVNode("td", _hoisted_40, _toDisplayString(_ctx.formatUsdSmall(Number(dest.amountUsd || 0))), 1),
                                        _createElementVNode("td", _hoisted_41, _toDisplayString(_ctx.formatBtc(dest.amountBtc || 0)), 1),
                                        _createElementVNode("td", _hoisted_42, _toDisplayString(dest.note), 1)
                                      ]))
                                    }), 128))
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ])
              ]),
              (_ctx.totalPages > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, " Página " + _toDisplayString(_ctx.sentPage + 1) + " de " + _toDisplayString(_ctx.totalPages) + " · " + _toDisplayString(_ctx.sentTotalCount) + " registros ", 1),
                    _createElementVNode("nav", _hoisted_45, [
                      _createElementVNode("ul", _hoisted_46, [
                        _createElementVNode("li", {
                          class: _normalizeClass(["page-item", { disabled: _ctx.sentPage === 0 || _ctx.isSentLoading }])
                        }, [
                          _createElementVNode("button", {
                            class: "page-link",
                            type: "button",
                            disabled: _ctx.sentPage === 0 || _ctx.isSentLoading,
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToPage(0)))
                          }, " « ", 8, _hoisted_47)
                        ], 2),
                        _createElementVNode("li", {
                          class: _normalizeClass(["page-item", { disabled: _ctx.sentPage === 0 || _ctx.isSentLoading }])
                        }, [
                          _createElementVNode("button", {
                            class: "page-link",
                            type: "button",
                            disabled: _ctx.sentPage === 0 || _ctx.isSentLoading,
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.prevSentPage && _ctx.prevSentPage(...args)))
                          }, " ‹ ", 8, _hoisted_48)
                        ], 2),
                        (_ctx.showLeftEllipsis)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_49, [...(_cache[12] || (_cache[12] = [
                              _createElementVNode("span", { class: "page-link" }, "…", -1)
                            ]))]))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageWindow, (page) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: page,
                            class: _normalizeClass(["page-item", { active: page === _ctx.sentPage }])
                          }, [
                            _createElementVNode("button", {
                              class: "page-link",
                              type: "button",
                              disabled: _ctx.isSentLoading,
                              onClick: ($event: any) => (_ctx.goToPage(page))
                            }, _toDisplayString(page + 1), 9, _hoisted_50)
                          ], 2))
                        }), 128)),
                        (_ctx.showRightEllipsis)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_51, [...(_cache[13] || (_cache[13] = [
                              _createElementVNode("span", { class: "page-link" }, "…", -1)
                            ]))]))
                          : _createCommentVNode("", true),
                        _createElementVNode("li", {
                          class: _normalizeClass(["page-item", {
                  disabled:
                    _ctx.sentPage >= _ctx.totalPages - 1 || _ctx.isSentLoading || !_ctx.sentHasMore,
                }])
                        }, [
                          _createElementVNode("button", {
                            class: "page-link",
                            type: "button",
                            disabled: 
                    _ctx.sentPage >= _ctx.totalPages - 1 || _ctx.isSentLoading || !_ctx.sentHasMore
                  ,
                            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.nextSentPage && _ctx.nextSentPage(...args)))
                          }, " › ", 8, _hoisted_52)
                        ], 2),
                        _createElementVNode("li", {
                          class: _normalizeClass(["page-item", {
                  disabled:
                    _ctx.sentPage >= _ctx.totalPages - 1 || _ctx.isSentLoading || !_ctx.sentHasMore,
                }])
                        }, [
                          _createElementVNode("button", {
                            class: "page-link",
                            type: "button",
                            disabled: 
                    _ctx.sentPage >= _ctx.totalPages - 1 || _ctx.isSentLoading || !_ctx.sentHasMore
                  ,
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goToPage(_ctx.totalPages - 1)))
                          }, " » ", 8, _hoisted_53)
                        ], 2)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
    ])
  ]))
}